import { css, Theme, Interpolation } from '@emotion/react'
import { buttonBaseClasses } from '@mui/material'

export const head: Interpolation<Theme> = (theme) =>
  css`
    width: fit-content;
    min-width: 100%;
    display: flex;
    gap: ${theme.spacing(0.5)};
    padding: ${theme.spacing(0.75)};
    background: ${theme.colors.grayHover};
    border: 1px solid ${theme.colors.grayHover};
    border-radius: 14px;
    margin-bottom: 15px;
  `

export const columns: (columnsCount: number) => Interpolation<Theme> = (columnsCount) => (theme) =>
  css`
    min-width: ${columnsCount * 160}px;
    width: 100%;
    display: grid;
    align-items: center;
    grid-template-columns: repeat(${columnsCount}, 1fr);
    gap: ${theme.spacing(2)};
    padding: 0 ${theme.spacing(1)};
  `

export const buttons: (isColumnsEditable: boolean) => Interpolation<Theme> = (isColumnsEditable) => (theme) =>
  css`
    min-width: ${isColumnsEditable ? 116 : 76}px;
    display: flex;
    align-items: center;
    justify-content: right;
    gap: ${theme.spacing(0.5)};
  `

export const iconButton: Interpolation<Theme> = css`
  &.${buttonBaseClasses.root} {
    height: 36px;
    width: 36px;
    min-width: 36px;
    padding: 0;

    svg {
      height: 20px;
      width: 20px;
    }
  }
`

export const dndSpace: Interpolation<Theme> = css`
  min-width: 20px;
`
